import { cn } from '../../utils/cn'
import { FieldContext } from './field-context'

export function FieldRoot({
  children,
  className,
  orientation = 'vertical',
  size = 'md',
  ...props
}: FieldRoot.Props) {
  return (
    <FieldContext.Provider value={{ orientation, size }}>
      <div
        className={cn(
          'group/field-root',
          orientation === 'vertical' && 'flex flex-col gap-y-1',
          orientation === 'horizontal' &&
            'grid grid-cols-[1fr_auto] items-center gap-x-4 [&:has([data-slot=field-control]:first-child)]:grid-cols-[auto_1fr]',
          className
        )}
        {...props}
      >
        {children}
      </div>
    </FieldContext.Provider>
  )
}

export namespace FieldRoot {
  export type Props = React.ComponentProps<'div'> & Partial<FieldContext>
}
